import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useForm } from "react-hook-form";
import { userServices } from "../services";
import { TextField, Toast } from "../components";
// [CAPTCHA] import ReCAPTCHA from "react-google-recaptcha";

export default function ResetPassword() {
	const classes = useStyles();
	const { register, handleSubmit, errors } = useForm();
	const [toast, setToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [emailSent, setEmailSent] = useState(false);
	// [CAPTCHA] const [captchaValido, setCaptchaValido] = useState(null);

	// [CAPTCHA]
	// const onChangeCaptcha = () => {
	// 	setCaptchaValido(true);
	// };

	const resetPassword = async (data) => {
		// [CAPTCHA]
		// if (!captchaValido) {
		// 	setToast(true);
		// 	setToastMessage("Por favor verifique que no es un robot");
		// 	return;
		// }

		const { status, response } = await userServices.sendTokenResetPassword({ email: data.email });
		if (status === 200) {
			if (response.message === "success") {
				setEmailSent(true);
				setToast(true);
				setToastMessage("Corre enviado correctamente");
			} else {
				setToast(true);
				setToastMessage(response.error.message);
			}
		}
	};

	const onKeyDownHandler = (e) => {
		if (e.keyCode === 13) {
			e.preventDefault();
		}
	};

	return (
		<Container component="main" maxWidth="xs" className={classes.container}>
			<Toast
				message={toastMessage}
				open={toast}
				close={() => {
					setToast(false);
				}}
			/>
			<CssBaseline />
			<div className={classes.paper}>
				<img src="/Unio-01.png" alt="" style={{ width: 150 }} />
				{!emailSent ? (
					<form className={classes.form} noValidate onSubmit={handleSubmit(resetPassword)} onKeyDown={onKeyDownHandler}>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12}>
								<TextField
									variant="outlined"
									fullWidth
									id="email"
									label="Correo electrónico"
									name="email"
									size="small"
									placeholder="Correo electronico *"
									autoComplete="email"
									inputRef={register({
										required: "Correo requerido",
										pattern: {
											value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
											message: "Formato de correo inválido",
										},
									})}
									InputLabelProps={{
										shrink: true,
									}}
									error={errors.email ? true : false}
									helperText={errors.email ? errors.email.message : ""}
								/>
							</Grid>
							{/* [CAPTCHA]
							<Grid item xs={12} sm={12} className={classes.captchaContainer}>
								<ReCAPTCHA
									sitekey={process.env.REACT_APP_RECAPTCHA_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
									onChange={onChangeCaptcha}
								/>
							</Grid>
							*/}
						</Grid>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="secondary"
							className={classes.submit}
							disabled={false} /* [CAPTCHA] disabled={!captchaValido} */
						>
							Reestablecer contraseña
						</Button>
					</form>
				) : (
					<Grid container>
						<Grid item xs={12} sm={12}>
							<div className={classes.mailSent}>
								Consulte la bandeja de entrada de su correo electrónico para obtener un enlace y completar el restablecimiento de
								contraseña.
							</div>
						</Grid>
					</Grid>
				)}
			</div>
		</Container>
	);
}

const useStyles = makeStyles((theme) => ({
	container: {
		height: "100vh",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
	},
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%",
		marginTop: theme.spacing(3),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		borderRadius: 25,
	},
	mailSent: {
		fontSize: "18px",
		textAlign: "center",
		background: "rgb(228 235 244)",
		border: "1px solid rgb(195 200 231)",
		padding: "15px 5px",
		borderRadius: "0px",
		marginTop: "40px",
	},
	captchaContainer: {
		display: "flex",
		justifyContent: "center",
		marginTop: theme.spacing(2),
	},
}));
